import React from 'react';
import { connect } from 'react-redux';
import { Navbar , Footer } from '../../_components';

export class HWGCashPage extends React.Component
{
    render (){
        window.location.href = "/login";

        return (
            <React.Fragment>
                <Navbar/>
                <div className="columns border-bottom">
                    <div className="column is-6 is-12-mobile bg-dark-blue has-text-centered p-xl">
                        <img src="/images/hwgcash-white.png" width="200"/>
                        
                        <div class="is-size-4 m-t-lg">
                            Asia's First Regulated Stable Token
                        </div>
                        <div className="m-t-lg">
                            <a href="/account/deposit?type=hwgcash">
                                <button className="button is-primary is-multi-button is-outlined">
                                    Get HWG Cash
                                </button>
                            </a>
                            <a href="/account/redeemhwgcash">
                                <button className="button is-primary is-multi-button is-outlined">
                                    Redeem HWG Cash
                                </button>
                            </a>
                        </div>
                        
                        <div className="m-t-xl is-size-5">
                            Ticker : <span className="color-yellow">HWGC</span>
                        </div>
                        <div className="m-t-lg is-size-7">
                            Asia’s first regulated stable token pegged to the USD oversight by Labuan Financial Services Authority, Malaysia
                        </div>
                    </div>
                    <div className="column is-6  is-12-mobile has-text-centered p-xl">

                        <div class="hwginfo-block">
                            <div class="hwginfo-block-icon">
                                <img src="/images/icon-shield.png" width="22"/>
                            </div>
                            <div class="hwginfo-block-content">
                                <div class="hwginfo-block-heading">
                                    <h4>Issuer</h4>
                                </div>
                                <p class="hwginfo-block-body">
                                    HWG Cash is a licensed stable token issued by HWGG Capital P.L.C
                                </p>
                            </div>
                        </div>

                        <div class="hwginfo-block">
                            <div class="hwginfo-block-icon">
                                <img src="/images/icon-bank.png" width="22"/>
                            </div>
                            <div class="hwginfo-block-content">
                                <div class="hwginfo-block-heading">
                                    <h4>Bank</h4>
                                </div>
                                <p class="hwginfo-block-body">
                                    U.S Dollars deposited for the issuance and circulation of HWG Cash are held in designated Client’s Account under regulated supervision. 

                                </p>
                            </div>
                        </div>
                        
                        <div class="hwginfo-block">
                            <div class="hwginfo-block-icon">
                                <img src="/images/icon-reporting.png" width="22"/>
                            </div>
                            <div class="hwginfo-block-content">
                                <div class="hwginfo-block-heading">
                                    <h4>Reporting</h4>
                                </div>
                                <p class="hwginfo-block-body">
                                    HWGG Capital P.L.C is required to adhere to stringent reporting standard to Labuan FSA in regards to its account to ensure compliance. 

                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="section intro-panel">
                    <div className="columns p-lg">
                        <div className="column is-three-fifths is-offset-one-fifth has-text-centered">
                            <div className="m-t-lg is-size-4">
                                U.S Dollars on Blockchain 
                            </div>
                            <div className="m-t-lg is-size-6">
                                HWGG Capital P.L.C aims to provide price stability and payment solution to the mass market by introducing Asia’s first regulated stable token HWG Cash (ERC20/EVT). 
                            </div>
                            <div className="m-t-lg is-size-6">
                                HWG Cash is Pegged 1-to-1 to the US Dollar 
                            </div>
                            
                            <div className="m-t-xl is-size-1">
                                <span className="color-yellow">
                                <img src="/images/hwgcash-black.png" width="130"/> 1
                                </span>  : 1  
                                <img src="/images/usd.png" width="130"/>
                            </div>
                        </div>
                    </div>
                
                </section>
                
                <section className="section intro-panel bg-dark-blue">
                    <div className="columns p-lg">
                        <div className="column is-four-sixths is-offset-one-sixth has-text-centered">
                            <div className="m-t-lg is-size-4">
                                How HWG Cash Works 
                            </div>
                            <div className="columns m-t-lg">
                                <div className="column is-6 p-lg">
    
                                    <div class="hwgsteps-block">
                                        <div class="hwgsteps-block-icon">
                                            Step 1 - 
                                        </div>
                                        <div class="hwgsteps-block-content">
                                            <p class="hwgsteps-block-body">
                                                User deposits fiat currency to HWGG Capital P.L.C's bank account
                                            </p>
                                        </div>
                                    </div>
                                    
                                    <div class="hwgsteps-block">
                                        <div class="hwgsteps-block-icon">
                                            Step 2 - 
                                        </div>
                                        <div class="hwgsteps-block-content">
                                            <p class="hwgsteps-block-body">
                                                HWG Cash will be generated and credits to the user's HwgX wallet. HWG Cash circulating supply increases. Amount of fiat currency deposited by user = amount of HWG Cash issued to user (ie. USD 10,000 deposited = HWG Cash 10,000 issued)
                                            </p>
                                        </div>
                                    </div>

                                    <div class="hwgsteps-block">
                                        <div class="hwgsteps-block-icon">
                                            Step 3 - 
                                        </div>
                                        <div class="hwgsteps-block-content">
                                            <p class="hwgsteps-block-body">
                                                Users transact with HWG Cash. The users can transfer, exchange and store HWG Cash via HwgX app or any ERC-20 compliant wallet.
                                            </p>
                                        </div>
                                    </div>
                                    
                                    <div class="hwgsteps-block">
                                        <div class="hwgsteps-block-icon">
                                            Step 4 - 
                                        </div>
                                        <div class="hwgsteps-block-content">
                                            <p class="hwgsteps-block-body">
                                                The user deposits HWG CAsh with HWGG Capital P.L.C for redemption into fiat currency.
                                            </p>
                                        </div>
                                    </div>
                                    
                                    <div class="hwgsteps-block">
                                        <div class="hwgsteps-block-icon">
                                            Step 5 - 
                                        </div>
                                        <div class="hwgsteps-block-content">
                                            <p class="hwgsteps-block-body">
                                                HWGG Capital P.L.C sends fiat currency to the user's bank account.
                                            </p>
                                        </div>
                                    </div>

                                </div>
                                <div className="column is-6">
                                    <div className="is-size-8">
                                        The Flow of Funds diagram illustrates that HWGG Capital P.L.C is the only party who can issue HWG Cash into circulation (create) and take them out of circulation (destroy) to ensure system solvency is maintained.  

                                    </div>
                                    <img src="/images/hwgcash-steps.jpg" width="100%" />
                                </div>
                            </div>
                        </div>
                    </div>
                
                </section>

                <section className="section intro-panel">
                    <div className="columns p-lg">
                        <div className="column is-four-sixths is-offset-one-sixth has-text-centered">
                        
                            <div className="m-t-lg is-size-4">
                                The Future of Blockchain Assets  
                            </div>
                            <div className="columns m-t-lg">
                                <div className="column is-6 p-xl">
                                    <img src="/images/icon-digitalmoney.png" width="120"/>
                                    <div className="p-t-md">
                                        <strong>Digital Money for Everyone </strong>
                                    </div>
                                    <div className="p-t-md">
                                    Send and Receive U.S Dollars through the blockchain network – fast, secure and diligent
                                    </div>
                                </div>
                                
                                <div className="column is-6 p-xl">
                                    <img src="/images/icon-exchanges.png" width="120"/>
                                    <div className="p-t-md">
                                    <strong>Exchanges </strong>
                                    </div>
                                    <div className="p-t-md">
                                    List HWG Cash as trading pairs for fiat solution
                                    </div>
                                </div>
                            </div>
                            
                            <div className="columns m-t-lg">
                                <div className="column is-6 p-lg">
                                    <img src="/images/icon-business.png" width="120"/>
                                    <div className="p-t-md">
                                    <strong>Online and Offline Business</strong>  
                                    </div>
                                    <div className="p-t-md">
                                    Expand your market into the crypto world by accepting HWG Cash as a form of payment – Risk Free! 
                                    </div>
                                </div>
                                
                                <div className="column is-6  p-lg">
                                    <img src="/images/icon-traders.png" width="120"/>
                                    <div className="p-t-md">
                                    <strong>Traders</strong> 
                                    </div>
                                    <div className="p-t-md">
                                    Use HWG Cash to purchase cryptocurrencies  
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                
                </section>

                <Footer/>
            </React.Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Views/HWGCashPage/HWGCashPage.jsx